<template>
  <div>
    <button class="btn btn-success mx-2 " @click="btnClicked"><i class="icon-content-duplicate"></i></button>
    <button class="btn btn-secondary mx-2" @click="btnEditClicked(row.id)"><i class="icon-bd-pencil"></i>
    </button>
    <button class="btn btn-secondary mx-2" @click="btnDeleteClicked(row.id)"><i class="icon-delete-empty"></i></button>


    <b-modal
      ref="editOrderModal"
      id="edit-order"
      size="xl"
      title="افزودن سفارش جدید"
      ok-title="ذخیره"
      cancel-title="لغو"
      @ok="updateOrder"
      @cancel="hideModal"
    >
      <order-form ref="orderForm" :order-row="row" :order-edit-mode="editMode"
                  @edit-order-object="orderValues"></order-form>
    </b-modal>

    <b-modal
      ref="deleteCustomerOrderModal"
      id="delete-customer-order"
      :header-bg-variant="headerBgVariant"
      :body-bg-variant="bodyBgVariant"
      :footer-bg-variant="footerBgVariant"
      :header-text-variant="headerTextVariant"
      size="sm"
      title="حذف سفارش"
      ok-title="حذف"
      cancel-title="لغو"
      @cancel="hideModal"
      @ok="deleteOrder"
      centered
    >
      <h6>آیا مایل به حذف سفارش هستید؟</h6>
    </b-modal>


  </div>
</template>

<script>
    import * as $ from 'jquery';
    import VsTable from "../_framework/VsTable.vue";
    import VsTableMixin from "../_framework/VsTableMixin.js";
    import OrderForm from "../components/OrderForm";
    import BaseService from "../_framework/api/BaseService";

    export default {
        name: 'customer-order-operations',
        props: ['header', 'row'],
        data() {
            return {
                show: true,
                orderModel: {},
                editMode: false,
                orderId: 0,
                footerBgVariant: 'light',
                bodyBgVariant: 'light',
                headerBgVariant: 'danger',
                headerTextVariant: 'white',
            }
        },
        mounted() {

        },
        methods: {
            btnClicked() {
                this.$emit('toggleInnerBox');

            },
            btnEditClicked() {
                // console.log(this.row);
                this.$refs.editOrderModal.show();
                this.editMode = true;
                if (this.editMode === true) {
                    this.$emit('editCustomerOrder', this.row)
                }
            },
            btnDeleteClicked(id) {
                // console.log(this.row)
                this.$refs.deleteCustomerOrderModal.show();
                this.orderId = id
            },
            updateOrder() {
                new BaseService('CustomerOrders', "/Update").update(this.orderModel).then((response) => {
                    this.$noty.success("سفارش با موفقیت ویرایش شد");

                    this.$emit('refreshTAble', this.refreshTable());
                }).catch((error) => {
                    console.log(error);
                })
            },

            hideModal() {
                this.refreshTable();
                this.editMode = false;
                this.$root.$emit('bv::hide::editOrderModal', 'edit-order', '#btnShow');
                this.$root.$emit('bv::hide::deleteCustomerOrderModal', 'delete-customer-order', '#btnShow')
            },
            refreshTable() {

                this.show = false;
                setTimeout(() => {
                    this.show = true;
                }, 50);
                // this.$refs.table.onFetchEntityList();
            },
            orderValues(value) {
                // console.log(value);
                this.orderModel = value;
            },
            deleteOrder() {
                let id = this.orderId;
                new BaseService('CustomerOrders', `/Remove/${id}`).delete().then((response) => {
                    this.$noty.success("سفارش با موفقیت حذف شد");
                }).catch((error) => {
                    console.log(error);
                })
            },
        }
    }
</script>

<style scoped>

</style>
